import { supabase } from '../config/supabase';

export interface Business {
  id: string;
  name: string;
  address?: string;
  phone?: string;
  email?: string;
  logo_url?: string;
  created_at: string;
  updated_at: string;
}

export const businessService = {
  // Get business by ID (public access - no authentication required)
  async getBusinessById(id: string): Promise<{ business: Business | null; error: Error | null }> {
    try {
      const { data, error } = await supabase
        .from('businesses')
        .select('*')
        .eq('id', id)
        .single();

      if (error) throw error;
      return { business: data, error: null };
    } catch (error) {
      return { business: null, error: error as Error };
    }
  },

  // Get business by repair order ID (public access)
  async getBusinessByRepairOrderId(repairOrderId: string): Promise<{ business: Business | null; error: Error | null }> {
    try {
      // First get the repair order to find the business_id
      const { data: repairOrder, error: roError } = await supabase
        .from('repair_orders')
        .select('business_id')
        .eq('id', repairOrderId)
        .single();

      if (roError) throw roError;
      if (!repairOrder?.business_id) {
        throw new Error('Repair order not found or has no associated business');
      }

      // Then get the business information
      return await this.getBusinessById(repairOrder.business_id);
    } catch (error) {
      return { business: null, error: error as Error };
    }
  },
};